export default "__VITE_ASSET__CTCcv_$l__"